(() => {
  if (window.auraOnoInstalled) return;
  window.auraOnoInstalled = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-aono-marquee-toggle]');
    if (!button) return;
    const paused = button.getAttribute('aria-pressed') !== 'true';
    button.setAttribute('aria-pressed', String(paused));
    button.setAttribute('aria-label', paused ? 'Play announcement' : 'Pause announcement');
    button.textContent = paused ? '▶' : 'Ⅱ';
    button.parentElement.querySelector('.aurasync-announcement__track').style.animationPlayState = paused ? 'paused' : '';
  });
  function videos(scope = document) {
    scope.querySelectorAll('.aono-video').forEach((box) => {
      const video = box.querySelector('video');
      const button = box.querySelector('[data-aono-video-toggle]');
      if (!video || !button || button.dataset.ready) return;
      button.dataset.ready = 'true'; button.hidden = false;
      const sync = () => { button.textContent = video.paused ? 'Play video' : 'Pause video'; button.setAttribute('aria-pressed', String(!video.paused)); };
      let manuallyPaused = false;
      button.addEventListener('click', () => { manuallyPaused = !video.paused; video.paused ? video.play().catch(sync) : video.pause(); });
      video.addEventListener('play', sync); video.addEventListener('pause', sync);
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) { video.autoplay=false; video.pause(); sync(); }
      else if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
          if (entry.isIntersecting && !manuallyPaused && !document.hidden) video.play().catch(sync);
          else if (!entry.isIntersecting) video.pause();
        }), {threshold: .3});
        observer.observe(video);
      }
    });
  }
  videos(); document.addEventListener('shopify:section:load', (event) => videos(event.target));
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.aono-product-form');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[name="add"]');
    if (!button || button.disabled) return;
    const status = form.querySelector('.aono-status');
    const root = window.Shopify?.routes?.root || '/';
    button.disabled = true; status.textContent = 'Adding…';
    if (form.dataset) form.dataset.cartLocked = 'true';
    let uncertain = false;
    let added = false;
    let failedAfterAdd = false;
    try {
      const fields = new FormData(form);
      let items;
      if (form.dataset.bundlePayload) {
        items = JSON.parse(form.dataset.bundlePayload);
        if (!items.length || items.reduce((sum, item) => sum + item.quantity, 0) < 2) throw new Error('Choose at least two items.');
      } else {
        const item = {id:Number(fields.get('id')), quantity:Number(fields.get('quantity') || 1)};
        if (!item.id || !Number.isInteger(item.quantity) || item.quantity < 1) throw new Error('Choose a valid option and quantity.');
        if (fields.get('selling_plan')) item.selling_plan = Number(fields.get('selling_plan'));
        const properties = {};
        for (const [key,value] of fields.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string') properties[match[1]] = value;
        }
        if (Object.keys(properties).length) item.properties = properties;
        items = [item];
      }
      const payload = JSON.stringify({items});
      const headers = {Accept:'application/json','Content-Type':'application/json'};
      uncertain = true;
      const response = await fetch(`${root}cart/add.js`, {method:'POST',headers,body:payload});
      let result;
      try { result = await response.json(); }
      catch {
        throw new Error('We could not confirm your cart update. Open your cart to check before trying again.');
      }
      uncertain = response.status >= 500;
      if (!response.ok) throw new Error(result.description || 'Unable to add this item.');
      added = true;
      // Use a non-cart page: this Horizon drawer intentionally does not render on /cart.
      const [renderResponse, cartResponse] = await Promise.all([
        fetch(`${root}?sections=cart-drawer-section`,{headers:{Accept:'application/json'}}),
        fetch(`${root}cart.js`,{headers:{Accept:'application/json'}})
      ]);
      if (!renderResponse.ok || !cartResponse.ok) throw new Error('Added. Open your cart to review your order.');
      const sections = await renderResponse.json();
      const cart = await cartResponse.json();
      document.querySelectorAll('[data-aurasync-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
      const current = document.getElementById('shopify-section-cart-drawer-section');
      if (current && sections['cart-drawer-section']) {
        current.outerHTML = sections['cart-drawer-section'];
        const drawer = document.getElementById('cart-drawer');
        if (typeof drawer?.open === 'function') drawer.open();
        else { window.location.assign(`${root}cart`); return; }
      } else { window.location.assign(`${root}cart`); return; }
      status.textContent = 'Added to your cart.';
    } catch (error) {
      status.textContent = added ? 'Your item was added. Open your cart to review it.' : uncertain ? 'We could not confirm your cart update. Open your cart to check before trying again.' : error.message;
      if (added || uncertain) {
        failedAfterAdd = true;
        const link = document.createElement('a'); link.href = `${root}cart`; link.textContent = ' View cart'; status.append(link);
      }
    } finally { button.disabled = failedAfterAdd; if (form.dataset) form.dataset.cartLocked = String(failedAfterAdd); }
  });
})();

// Native buttons focus the chosen format while preserving side-by-side comparison.
document.addEventListener('click', (event) => {
  const choice = event.target.closest?.('[data-aono-choice]');
  if (!choice) return;
  const section = choice.closest('.aono');
  section.querySelectorAll('[data-aono-choice]').forEach(button => button.setAttribute('aria-pressed', String(button === choice)));
  section.querySelectorAll('[data-aono-offer]').forEach(card => card.classList.toggle('is-selected', card.dataset.aonoOffer === choice.dataset.aonoChoice));
  const card = section.querySelector(`[data-aono-offer="${choice.dataset.aonoChoice}"]`);
  if (window.matchMedia('(max-width: 749px)').matches) card?.scrollIntoView({block:'center',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
});

(()=>{document.querySelectorAll('[data-aono-matrix]').forEach(root=>{const buttons=[...root.querySelectorAll('[data-aono-matrix-filter]')],cards=[...root.querySelectorAll('[data-aono-matrix-card]')];buttons.forEach(button=>button.addEventListener('click',()=>{const filter=button.dataset.aonoMatrixFilter;buttons.forEach(x=>{const active=x===button;x.classList.toggle('is-active',active);x.setAttribute('aria-pressed',String(active));});cards.forEach(card=>{card.hidden=filter!=='all'&&card.dataset.productType!==filter;});}));});})();

// A quiet, dismissible invitation; never interrupts a form, media, or another overlay.
(()=>{
 let timer; const key='aura-invitation-seen';
 const seen=()=>{try{return sessionStorage.getItem(key)==='true';}catch{return false;}};
 const show=()=>{
  if(seen()||document.hidden||document.activeElement?.matches('input,textarea,select')||document.querySelector('dialog[open],.aura-exit-intent.is-visible,.aura-reels__modal:not([hidden])')||[...document.querySelectorAll('video')].some(v=>!v.paused))return;
  const box=document.createElement('aside');box.className='aura-idle-prompt';box.setAttribute('aria-label','A quiet pause');box.innerHTML='<p>A moment away from the screen?</p><p>Rest your hands. Take a comfortable breath.</p><button type="button">Keep exploring</button>';box.querySelector('button').onclick=()=>box.remove();document.body.append(box);try{sessionStorage.setItem(key,'true');}catch{}
 };
 const reset=()=>{clearTimeout(timer);timer=setTimeout(show,120000);};
 ['pointerdown','keydown','scroll','touchstart'].forEach(event=>document.addEventListener(event,reset,{passive:true}));document.addEventListener('visibilitychange',reset);reset();
})();

(()=>{
 const cards=[...document.querySelectorAll('[data-catalog-handle]')],buttons=[...document.querySelectorAll('[data-catalog-group]')];
 const groups={sleep:['olfactory-anchor-shutdown-dome','deep-rest-pressure-veil-somatic-shutdown','neuro-rest-geode-sleep-anchor','crystal-resonance-lamp-amethyst-halo'],focus:['silent-desk-fidget-stone','obsidian-mass-thermal-shield','energetic-shield-anchor-ii','volcanic-matrix','chevron-matrix-emotional-anchor','raw-paleozoic-matrix-archive-specimen','reset-tab-clarity-anchor','mineral-infusion-hydration-vessel','the-phoenix-burn-pair']};
 function select(group){buttons.forEach(b=>{b.setAttribute('aria-pressed',String(b.dataset.catalogGroup===group));b.classList.toggle('is-active',b.dataset.catalogGroup===group);});cards.forEach(c=>c.hidden=group!=='all'&&!groups[group]?.includes(c.dataset.catalogHandle));}
 buttons.forEach(b=>b.addEventListener('click',()=>select(b.dataset.catalogGroup)));
 const initial=new URLSearchParams(location.search).get('group');if(groups[initial])select(initial);
})();

(() => {
  document.querySelectorAll('[data-aura-features]').forEach(root => {
    const tabs = [...root.querySelectorAll('[data-aura-feature]')];
    const activate = tab => {
      tabs.forEach(t => { const selected = t === tab; t.setAttribute('aria-selected', String(selected)); t.tabIndex = selected ? 0 : -1; });
      root.querySelectorAll('[data-aura-feature-panel]').forEach(panel => {
        panel.hidden = panel.dataset.auraFeaturePanel !== tab.dataset.auraFeature;
        const video = panel.querySelector('video');
        if (panel.hidden) video?.pause();
        else if (!matchMedia('(prefers-reduced-motion: reduce)').matches) video?.play().catch(() => {});
      });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', event => {
        const next = event.key === 'ArrowRight' ? (index + 1) % tabs.length : event.key === 'ArrowLeft' ? (index + tabs.length - 1) % tabs.length : event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : null;
        if (next !== null) { event.preventDefault(); tabs[next].focus(); activate(tabs[next]); }
      });
    });
  });
})();
